import axios from "@/axios";
import { mapGetters, mapMutations } from "vuex/dist/vuex.common.js";
export const visitorsMixin = {
  data() {
    return {
      createVisitors: false,
      searchVisitor: true,
      visitorDisabled: true,
    }
  },
  methods: {
    ...mapMutations(["setPersonTypeCount"]),
    onFormVisitors(event) {
      this.createVisitors = true;
      this.searchVisitor = this.$store.state.viewPatient;
      this.visitorDisabled = event;
    },
    backVisitor() {
      (this.createVisitors = false),
        (this.searchVisitor = true),
        (this.visitorDisabled = true),
        this.clearForm();
    },
    clearForm() {
      for (var value in this.saveForm) {
        if (value !== "permanence") {
          this.saveForm[value] = "";
        }
      }
      this.date = "";
    },
    getPersonTypeReturnCount() {
        axios.post("person/return-person-type-count", {
                    personType: this.$store.state.aghusePatient.nome_paciente,
                  })
                  .then((data) => {
                    const { qtyVisitor, qtyEscort, save, limit } = data.data
                    this.setPersonTypeCount({
                      qtyVisitor: qtyVisitor,
                      qtyEscort: qtyEscort,
                      save: save,
                      limit: limit,
                    });

                  });
    },
  },
  computed: {
    ...mapGetters([
      "getPersonTypeCount",
      "isCounted",
      "getPersonType",
      "getDocumentType",
      "getSexualOrientation",
      "getUnity",
      "getKinship"
      ]),
  }
}